import type { Variants, Transition } from "framer-motion";

export const EASE_ENTER: [number, number, number, number] = [0.16, 1, 0.3, 1];
export const EASE_EXIT: [number, number, number, number] = [0.7, 0, 0.84, 0];
export const SPRING_TOUCH = { type: "spring", stiffness: 420, damping: 32 } as const satisfies Transition;
export const DUR = { micro: 0.12, ui: 0.22, scene: 0.42, hero: 0.9 } as const;

export const stepVariants: Variants = {
  enter: (dir: 1 | -1) => ({ opacity: 0, x: 24 * dir }),
  center: { opacity: 1, x: 0, transition: { duration: DUR.scene, ease: EASE_ENTER } },
  exit: (dir: 1 | -1) => ({ opacity: 0, x: -24 * dir, transition: { duration: DUR.ui, ease: EASE_EXIT } }),
};

export const staggerChildren = (delay = 0.04): Variants => ({
  hidden: {},
  show: { transition: { staggerChildren: delay, delayChildren: 0.05 } },
});

export const riseItem: Variants = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: DUR.ui, ease: EASE_ENTER } },
};
